import 'css-chunk:../../src/components/back-button/index.module.scss';export default {
  "back_button": "_back_button_1eim7_1"
};